import { createContext, ReactNode } from 'react';
import { Locales } from './interfaces';

export const LocalesContext = createContext<Locales>({} as Locales);

interface Props {
  locales: Locales;
  children: ReactNode;
}
export const WithLocales = ({ locales, children }: Props) => (
  <LocalesContext.Provider value={locales}>{children}</LocalesContext.Provider>
);
